// @flow
import React from 'react';
import injectSheet from 'react-jss';
import _ from 'shared/lib/gettext';
import Button from '~/app/components/Button';
import { S, A, DARK } from '~/app/ui/tokens';

type Props = {
  classes: Object,
  message: string,
  actionLabel: string,
  onClick: Function,
  onClose: Function
};

/**
 * The older screens' confirmation, drawn like the new ConfirmDialog
 * (app/ui/ConfirmDialog): the question, then Cancel and the action on the right.
 */
function ConfirmationModal({
  classes: c, message, actionLabel, onClick, onClose
}: Props) {
  return (
    <div className={c.bg} role="presentation">
      <div className={c.container} role="alertdialog" aria-modal="true">
        {onClose &&
          <button
            type="button"
            onClick={onClose}
            className={c.close}
            aria-label={_('CANCEL')}
          >
            <i className="material-icons" aria-hidden>close</i>
          </button>
        }
        <div className={c.message}>{message}</div>
        {actionLabel &&
          <div className={c.actionGroup}>
            <Button
              size="md"
              secondary
              onClick={onClose}
            >
              {_('CANCEL')}
            </Button>
            <Button
              size="md"
              primary
              onClick={onClick}
            >
              {actionLabel}
            </Button>
          </div>
        }
      </div>
    </div>
  );
}

const styles = {
  bg: {
    position: 'fixed',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    background: 'rgba(23, 26, 32, 0.36)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    zIndex: 3000,
    [DARK]: { background: S.scrim }
  },
  container: {
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 440,
    padding: '24px 24px 20px',
    background: A.surface,
    borderRadius: 12,
    boxShadow: A.pop,
    fontFamily: S.ui,
    color: S.fg,
    position: 'relative'
  },
  close: {
    all: 'unset',
    position: 'absolute',
    right: 10,
    top: 10,
    width: 28,
    height: 28,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
    color: S.muted,
    cursor: 'pointer',
    '& .material-icons': { fontSize: 18 },
    '&:hover': { background: S.chromeHover, color: S.fg },
    '&:focus-visible': A.focus
  },
  message: {
    paddingRight: 24,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.45
  },
  actionGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 22
  }
};

export default injectSheet(styles)(ConfirmationModal);
